var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item)?_c('div',{staticClass:"row mb-1"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card mb-3 com-card pt-md-3"},[_c('proj-body',{attrs:{"item":_vm.item,"pub":false}})],1)])]):_c('not-found-msg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }